// extracted by mini-css-extract-plugin
export default {"xs":"374px","sm":"740px","md":"1024px","lg":"1280px","xl":"1680px","redeemForm":"Rq7xQnmDVdVmrTQ0Bn6O","redeemTextInput":"e6v3PCYTM6JT6VpHaQIr","redeemCta":"dZX0OLyHX3C6LWUnLaGJ"};